/*
 * Copyright (C) 2018 - present by OpenGamma Inc. and the OpenGamma group of companies
 *
 * Please see distribution for license.
 */

import { Component } from '@angular/core';
import { UserLogin } from 'app/user-auth/store';
import { Store } from '@ngrx/store';
import { State } from 'app/main/store';
import { environment } from 'environments/environment';

@Component({
  selector: 'og-admin',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent {
  environment = environment;

  constructor(store: Store<State>) {
    store.dispatch(new UserLogin());
  }
}
